'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var react = require('@chakra-ui/react');
react.AspectRatio.displayName = 'AspectRatio';
Object.defineProperty(exports, 'AspectRatio', {
  enumerable: true,
  get: function () {
    return react.AspectRatio;
  }
});